import React from 'react';
import { Alert } from "react-bootstrap";
import { VscSearchStop } from "react-icons/vsc";
import './AlertMessages.scss'
const msgOne = "OOPS! something went wrong!";
const msgTwo = "Please check your internet connection or refresh the page.";

export const ErrorComponent = () => {
    return (
        <Alert className="textCenter">
            <svg
                style={{
                    fill: '#aaaaaa',
                    width: 90,
                    margin: '0 auto'
                }}
                id="_1_px" data-name="1 px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 490.6"><defs></defs>
                <path className="cls-1"
                    d="M485,266.7H250.3a32.09,32.09,0,0,1-32-32,30.05,30.05,0,0,1,5-17L340.4,26a31.81,31.81,0,0,1,54.5.2L512.2,218a29.56,29.56,0,0,1,4.8,16.7,32.09,32.09,0,0,1-32,32ZM367.7,32a10.37,10.37,0,0,0-8.9,4.9L241.3,229.1a9.08,9.08,0,0,0-1.6,5.5,10.71,10.71,0,0,0,10.7,10.7H485a10.71,10.71,0,0,0,10.7-10.7,9.6,9.6,0,0,0-1.4-5.2L376.7,37.1a10.4,10.4,0,0,0-9-5.1Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M367.7,181.3A10.71,10.71,0,0,1,357,170.6V85.3a10.7,10.7,0,1,1,21.4,0v85.3A10.71,10.71,0,0,1,367.7,181.3Z" transform="translate(-5 -10.7)" /><circle className="cls-1" cx="362.7" cy="202.6" r="10.7" /><path className="cls-1" d="M66.4,266.7a10.75,10.75,0,0,1-7.6-3.1L17.4,222.2a42.85,42.85,0,0,1,.1-60.4L92.1,87.2c15.8-15.9,44.4-15.9,60.3,0l41.4,41.3a10.68,10.68,0,1,1-15.1,15.1l-41.4-41.4c-8-8-22.2-8-30.1,0L32.5,176.9A21.52,21.52,0,0,0,26.2,192a21.12,21.12,0,0,0,6.3,15L74,248.4a10.75,10.75,0,0,1-7.6,18.3Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M239.7,416a31.91,31.91,0,0,1-22.7-9.3l-29.2-29.1-41.1-4.5a52.29,52.29,0,0,1-32-15.2L57,300a32.35,32.35,0,0,1,0-45.4l128-128c12-12,33.4-12,45.4,0l8.7,8.7A10.68,10.68,0,1,1,224,150.4l-8.7-8.7a11.13,11.13,0,0,0-15.2,0l-128,128a10.87,10.87,0,0,0,0,15.2l57.8,57.8a31.76,31.76,0,0,0,19,9.1l45,4.9a10.49,10.49,0,0,1,6.4,3.1l31.8,31.8a11.13,11.13,0,0,0,15.2,0L322,316.9a10.66,10.66,0,0,0,3.1-7.6,8.54,8.54,0,0,0-1.3-4.9,10.64,10.64,0,0,1,17.9-11.5,29.68,29.68,0,0,1,4.7,16.4,31.91,31.91,0,0,1-9.3,22.7l-74.7,74.7a32.08,32.08,0,0,1-22.7,9.3Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M421,458.7a10.75,10.75,0,0,1-7.6-3.1L306.8,348.9a10.68,10.68,0,0,1,15.1-15.1L428.6,440.5a10.62,10.62,0,0,1,0,15.1A11.19,11.19,0,0,1,421,458.7Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M378.3,501.3a10.75,10.75,0,0,1-7.6-3.1L264.1,391.6a10.68,10.68,0,1,1,15.1-15.1L385.9,483.2a10.62,10.62,0,0,1,0,15.1A10.91,10.91,0,0,1,378.3,501.3Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M79.7,202.7a10.75,10.75,0,0,1-7.6-3.1L33.5,161a10.68,10.68,0,1,1,15.1-15.1l38.6,38.6a10.62,10.62,0,0,1,0,15.1,11,11,0,0,1-7.5,3.1Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M122.3,160a10.75,10.75,0,0,1-7.6-3.1L76.1,118.3a10.68,10.68,0,0,1,15.1-15.1l38.6,38.6a10.62,10.62,0,0,1,0,15.1A10.19,10.19,0,0,1,122.3,160Z"
                        transform="translate(-5 -10.7)" />
            </svg>
            <div style={{
                fontSize: 20, marginTop: 6, color: "#aaaaaa", fontWeight: 'normal'
            }}>
                {msgOne}
            </div>
            <div
                style={{
                    fontSize: 14, color: "#aaaaaa", marginTop: 6,
                }}
            >
                {msgTwo}
            </div>
        </Alert>
    )
}


export const ErrorComponentLight = () => {
    return (
        <Alert className="textCenter">

            <svg
                style={{
                    fill: '#f6f6f6',
                    width: 90,
                    margin: '0 auto'
                }}
                id="_1_px" data-name="1 px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 490.6"><defs></defs>
                <path className="cls-1"
                    d="M485,266.7H250.3a32.09,32.09,0,0,1-32-32,30.05,30.05,0,0,1,5-17L340.4,26a31.81,31.81,0,0,1,54.5.2L512.2,218a29.56,29.56,0,0,1,4.8,16.7,32.09,32.09,0,0,1-32,32ZM367.7,32a10.37,10.37,0,0,0-8.9,4.9L241.3,229.1a9.08,9.08,0,0,0-1.6,5.5,10.71,10.71,0,0,0,10.7,10.7H485a10.71,10.71,0,0,0,10.7-10.7,9.6,9.6,0,0,0-1.4-5.2L376.7,37.1a10.4,10.4,0,0,0-9-5.1Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M367.7,181.3A10.71,10.71,0,0,1,357,170.6V85.3a10.7,10.7,0,1,1,21.4,0v85.3A10.71,10.71,0,0,1,367.7,181.3Z" transform="translate(-5 -10.7)" /><circle className="cls-1" cx="362.7" cy="202.6" r="10.7" /><path className="cls-1" d="M66.4,266.7a10.75,10.75,0,0,1-7.6-3.1L17.4,222.2a42.85,42.85,0,0,1,.1-60.4L92.1,87.2c15.8-15.9,44.4-15.9,60.3,0l41.4,41.3a10.68,10.68,0,1,1-15.1,15.1l-41.4-41.4c-8-8-22.2-8-30.1,0L32.5,176.9A21.52,21.52,0,0,0,26.2,192a21.12,21.12,0,0,0,6.3,15L74,248.4a10.75,10.75,0,0,1-7.6,18.3Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M239.7,416a31.91,31.91,0,0,1-22.7-9.3l-29.2-29.1-41.1-4.5a52.29,52.29,0,0,1-32-15.2L57,300a32.35,32.35,0,0,1,0-45.4l128-128c12-12,33.4-12,45.4,0l8.7,8.7A10.68,10.68,0,1,1,224,150.4l-8.7-8.7a11.13,11.13,0,0,0-15.2,0l-128,128a10.87,10.87,0,0,0,0,15.2l57.8,57.8a31.76,31.76,0,0,0,19,9.1l45,4.9a10.49,10.49,0,0,1,6.4,3.1l31.8,31.8a11.13,11.13,0,0,0,15.2,0L322,316.9a10.66,10.66,0,0,0,3.1-7.6,8.54,8.54,0,0,0-1.3-4.9,10.64,10.64,0,0,1,17.9-11.5,29.68,29.68,0,0,1,4.7,16.4,31.91,31.91,0,0,1-9.3,22.7l-74.7,74.7a32.08,32.08,0,0,1-22.7,9.3Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M421,458.7a10.75,10.75,0,0,1-7.6-3.1L306.8,348.9a10.68,10.68,0,0,1,15.1-15.1L428.6,440.5a10.62,10.62,0,0,1,0,15.1A11.19,11.19,0,0,1,421,458.7Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M378.3,501.3a10.75,10.75,0,0,1-7.6-3.1L264.1,391.6a10.68,10.68,0,1,1,15.1-15.1L385.9,483.2a10.62,10.62,0,0,1,0,15.1A10.91,10.91,0,0,1,378.3,501.3Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M79.7,202.7a10.75,10.75,0,0,1-7.6-3.1L33.5,161a10.68,10.68,0,1,1,15.1-15.1l38.6,38.6a10.62,10.62,0,0,1,0,15.1,11,11,0,0,1-7.5,3.1Z" transform="translate(-5 -10.7)" /><path className="cls-1" d="M122.3,160a10.75,10.75,0,0,1-7.6-3.1L76.1,118.3a10.68,10.68,0,0,1,15.1-15.1l38.6,38.6a10.62,10.62,0,0,1,0,15.1A10.19,10.19,0,0,1,122.3,160Z"
                        transform="translate(-5 -10.7)" />
            </svg>

            <div style={{
                fontSize: 20, marginTop: 10, color: "#f6f6f6"
            }}>
                {msgOne}
            </div>
            <div
                style={{
                    fontSize: 14, color: "#f6f6f6", marginTop: 6,
                }}
            >
                {msgTwo}
            </div>
        </Alert>
    )
}

export const ItemNotFound = () => {
    return (
        <Alert className="itemNotFound textCenter">
            <VscSearchStop className="itemNotFoundIcon" />
            <div className="msgTitle">
                No results found
            </div>
            <div className="msgText">
            </div>
        </Alert>
    )
}

export const ItemNotFoundDynamic = ({ className, msgTitle, msgText }) => {
    return (
        <Alert className={className}>
            <VscSearchStop className="itemNotFoundIcon" />
            <div className="msgTitle">
                {msgTitle}
            </div>
            <div className="msgText">
                {msgText}
            </div>
        </Alert>
    )
}


export const FormSubmissionFailed = ({ msg }) => {
    return (
        <div className="errorMessage" style={{
            fontSize: 16, fontWeight: 'bold', marginBottom: 10
        }}>
            {msg ? msg : ' Action failed, please try again later.'}
        </div>
    )
}